import React from 'react'
import styled from 'styled-components'
import { Link } from 'atoms'
import PropTypes from 'prop-types'
import MicrophoneIcon from 'images/icons/Microphone'

const StyledLink = styled(Link)`
  padding: 4px;
`

const Microphone = ({ config }) => {
  return (
    <StyledLink href={config.url}>
      <MicrophoneIcon />
    </StyledLink>
  )
}

Microphone.propTypes = {
  config: PropTypes.shape({
    microphone: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
}

export default Microphone



// WEBPACK FOOTER //
// ./src/molecules/Microphone/index.js